import React from "react";
import { observer } from "mobx-react";
import { useRootAppStore } from "@hooks";
import {
	ChatHeader,
	ChatContent,
	ChatNameUpdate,
} from "@features/chat/desktop";

export default observer(function ChatBox() {
	const { chatViewStore } = useRootAppStore();

	if (!chatViewStore.chatBoxVisible) {
		return null;
	}

	if (!chatViewStore.chatDisplayName) {
		return <ChatNameUpdate />;
	}

	return (
		<>
			<div className="chat__card">
				<ChatHeader />
				<ChatContent />
			</div>
		</>
	);
});
